import { useUpdateUserNamesMutation } from "entities/user";
import { getUpdateUserNamesError } from "./getUpdateUserNamesError";
import { NameField, useNameField } from "./useNameField";

interface InitialNames {
  firstName: string | null;
  lastName: string | null;
}

interface UseEditUserNamesResult {
  firstName: NameField;
  lastName: NameField;
  canSubmit: boolean;
  isSubmitting: boolean;
  serverError: string | null;
  submit: () => Promise<void>;
}

export const useEditUserNames = (
  initial: InitialNames,
  onSuccess: () => void,
): UseEditUserNamesResult => {
  const [updateUserNames, { isLoading, error, reset }] =
    useUpdateUserNamesMutation();
  // Правка любого поля сбрасывает ошибку сервера от прошлой попытки.
  const firstName = useNameField(initial.firstName, reset);
  const lastName = useNameField(initial.lastName, reset);

  const isChanged = firstName.isChanged || lastName.isChanged;

  const submit = async () => {
    firstName.touch();
    lastName.touch();
    if (!firstName.isValid || !lastName.isValid || !isChanged) return;

    const result = await updateUserNames({
      first_name: firstName.value.trim(),
      last_name: lastName.value.trim(),
    });
    if (!("error" in result)) onSuccess();
  };

  return {
    firstName,
    lastName,
    canSubmit: isChanged && !isLoading,
    isSubmitting: isLoading,
    serverError: getUpdateUserNamesError(error),
    submit,
  };
};
